/**
 * 业务监测点国际化
 * date：2022 03 24
 */
export default {
  carrier: {
    incubator: 'Incubator',
    fridge: 'Refrigerator',
    car: 'Refrigerated Truck',
    refrigeratory: 'Cold Storage',
    warehouse: 'Warehouse',
    store: 'Store',
    // 后续有添加 监测点 则 需要手动在这里添加国际化
    run: 'Operational',
    backup: 'Standby',
    retirement: 'Disable',
    repaired: 'Under Maintenance',
    defrost: 'Defrosting',

    other: 'Other',

    1: 'Incubator',
    2: 'Refrigerator',
    3: 'Refrigerated Truck',
    4: 'Cold Storage',
    5: 'Warehouse',
    6: 'Store',
    7: 'Other',

    operate_failed: 'Operation Failed',
    operate_ok: 'Operation Successful'
  }
}
